import React, { createContext, useContext } from 'react';

export type ContextType = {
  redirect(action: string, params: any): void;
  navigate(action: string, params: any): void;
  emitEvent(action: string, params: any): void;
  redirectRouter(action: string, params: any): void;
};

export const LinkContext = createContext<ContextType>({} as ContextType);

/**
 * Redirect to deeplink or link
 * @name redirect
 * @function
 * @param {String} action Action to create deeplink
 * @param {Object} params Params to build the final url
 */

/**
 * @typedef {Object} useLinkContext
 * @property {redirect} redirect - Function redirect
 */

/**
 * useLinkContext
 *
 * @description Context for create link o deeplink base on plataform
 * @returns { useLinkContext }
 */
export const useLinkContext = () => {
  return useContext(LinkContext);
};
